module.exports = __webpack_public_path__ + "img/support-rescue.43991052.svg";